import type { ModuleTypeName } from './modules';

/**
 * Allowlist of typenames whose components consume the raw Contentful Entry shape
 * (sys + fields, with sys.contentType present) instead of the legacy
 * adapter-flattened shape.
 *
 * Consulted by `adaptRESTtoPageProps` (page fetch) and `adaptVariantEntry` /
 * `adaptBaselineEntry` (variant fetch) to skip post-adapter
 * annotation/restructure for these typenames. Module dispatch then happens
 * through `moduleRegistry[__typename]` like every other V2 module.
 *
 * Lives in this leaf module (with a type-only import of `ModuleTypeName`) so it
 * can be consumed from `libs/contentful/rest/adapter` without dragging the
 * component graph back in. Re-exported from `utils/modules` for the public API.
 *
 * The conventions every Entry-native component follows (props typing, Object
 * fields, rich text, unresolved links, migration checklist) are documented once
 * in `docs/contentful.md` under "Entry-native Modules".
 */
export const ENTRY_NATIVE_TYPENAMES: ReadonlySet<ModuleTypeName> = new Set<ModuleTypeName>([
  'Keyline',
  'FullWidthImage',
  'HeaderCta',
  'Subnav',
  'Note',
  'HeaderLogo',
  'DisclosureBanner',
  'ImpactHeadline',
  'CardsStacked',
  'CardsExpandable',
  'CardCarousel',
  'MapLocator',
  'AnimatedMarquee',
  'DisclosureAddOn',
  'Features',
  'ContentBlock',
  'Accordion',
  'Faq',
  'Compare',
  'FeaturedJobs',
  'Launchpad',
  'MediaCopyDivided',
  'DisclosureCollection',
  'BentoBox',
  'TeaserLinks',
  'CardsGridSimple',
  'CardsGridComplex',
  'CardsIcon',
  'CardsImage',
  'CalloutGrid',
]);
